/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type handleArchivedUserQueryVariables = {
    readonly accountId?: string | null;
};
export type handleArchivedUserQueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly userInfo: ({
            readonly id: string;
            readonly isArchived: boolean | null;
            readonly conciergeUser: ({
                readonly id: string;
                readonly isArchived: boolean | null;
            }) | null;
        }) | null;
    }) | null;
};
export type handleArchivedUserQuery = {
    readonly response: handleArchivedUserQueryResponse;
    readonly variables: handleArchivedUserQueryVariables;
};



/*
query handleArchivedUserQuery(
  $accountId: String
) {
  viewer {
    id
    userInfo(accountId: $accountId) {
      id
      isArchived
      conciergeUser {
        id
        isArchived
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "accountId",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isArchived",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
                (v1 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userInfo",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "accountId",
                            "type": "String"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "conciergeUser",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "handleArchivedUserQuery",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "handleArchivedUserQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "handleArchivedUserQuery",
            "id": null,
            "text": "query handleArchivedUserQuery(\n  $accountId: String\n) {\n  viewer {\n    id\n    userInfo(accountId: $accountId) {\n      id\n      isArchived\n      conciergeUser {\n        id\n        isArchived\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '441bae67e428c6d02dfe88b31cd255ed';
export default node;
